import { administratorNavigation } from './administrator';

// Super-admin uses the same navigation structure as administrator.
export const superAdminNavigation = administratorNavigation;
export const compactNavigation = superAdminNavigation;
export const futuristicNavigation = superAdminNavigation;
export const horizontalNavigation = superAdminNavigation;
